<template>
  <div id="camera-dialog" class="custom-modal">
    <div class="modal-body">
      <div class="select-div">
        <el-select v-model="currentCam" placeholder="Select" @change="cameraChanged($event)">
          <el-option v-for="item in currentMediaDevices" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </div>

      <transition name="bounce">
        <div class="camera-area" v-show="imageUrl == null">
          <span v-if="count > 0">{{ count }}</span>
          <video id="video" width="500" height="500" autoplay style="object-fit: cover;"></video>
        </div>
      </transition>

      <transition name="bounce">
        <div class="canvas-area" v-show="imageUrl != null">
          <canvas id="canvas" width="500" height="500"></canvas>
        </div>
      </transition>
    </div>
    <div class="modal-footer" slot="footer">
      <div class="left-buttons">
        <el-button @click="$emit('closeDialog')">{{ $t("components.participants.addPictureCamera.close") }}</el-button>
        <template v-if="imageUrl != null">
          <el-popconfirm @confirm="imageUrl = null" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
            <el-button slot="reference" type="danger" icon="fas fa-trash">{{ $t("components.participants.addPictureCamera.delete") }}</el-button>
          </el-popconfirm>
        </template>
      </div>
      <div class="right-buttons">
        <el-tooltip :content="$t('components.participants.addPictureCamera.again')" placement="top" :key="imageUrl">
          <el-button v-if="imageUrl != null" type="warning" @click="imageUrl = null"><i class="fas fa-sync-alt"></i></el-button>
        </el-tooltip>
        <el-button v-if="imageUrl != null" type="primary" :disabled="setImageKey == null" @click="setImageCallback">{{ $t("components.participants.addPictureCamera.save") }}</el-button>
        <el-button v-if="imageUrl == null" type="primary" @click="takePicture">{{ $t("components.participants.addPictureCamera.take") }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AddPictureCamera",
  components: {},
  props: [],
  data() {
    return {
      count: 0,
      interval: null,
      currentStream: null,
      videoArea: null,
      canvasArea: null,
      setImageKey: null,
      imageUrl: null,
      currentMediaDevices: [],
      currentCam: null,
      constraints: {
        video: true,
        audio: false
      }
    };
  },
  methods: {
    setImageCallback() {
      this.$emit("setImage", JSON.parse(JSON.stringify(this.setImageKey)));
      this.$emit("closeDialog");
    },
    async takePicture() {
      if (this.count == 0) {
        this.count = 3;
      }
      this.interval = setInterval(async () => {
        if (this.count > 0) {
          this.takePicture;
          this.count -= 1;
        } else {
          this.canvasArea.getContext("2d").drawImage(video, 0, 0, canvas.width, canvas.height);
          this.imageUrl = this.canvasArea.toDataURL("image/jpeg");
          this.count = 0;
          clearInterval(this.interval);
          var blob = await (await fetch(this.imageUrl)).blob();
          var file = new File([blob], "profile-picture.jpg", { type: "image/jpeg", lastModified: new Date() });
          var formData = new FormData();
          formData.append("file", file);
          var res = await this.$store.dispatch("setParticipantProfilePicture", formData);
          if (!res.data.alert.hasError) {
            this.setImageKey = res.data.data.item.url;
          }
          this.interval = null;
        }
      }, 1000);
    },
    async cameraChanged(event) {
      if (this.currentCam.value == event) {
        return;
      }
      if (this.currentStream !== "undefined" && this.currentStream != null) {
        await this.stopMediaTracks(this.currentStream);
      }
      const videoConstraints = {};
      if (event === "") {
        videoConstraints.facingMode = "environment";
      } else {
        videoConstraints.deviceId = { exact: event };
      }
      (this.constraints = {
        video: videoConstraints,
        audio: false
      }),
        navigator.mediaDevices
          .getUserMedia(this.constraints)
          .then(stream => {
            this.currentStream = stream;
            this.videoArea.srcObject = stream;
            return navigator.mediaDevices.enumerateDevices();
          })
          .then(this.getMediaDevices)
          .catch(error => {
            console.error(error);
          });
    },
    getMediaDevices(mediaDevices) {
      let count = 1;
      mediaDevices.forEach(mediaDevice => {
        if (mediaDevice.kind === "videoinput") {
          if (!this.currentMediaDevices.some(x => x.value == mediaDevice.deviceId)) {
            this.currentMediaDevices.push({
              value: mediaDevice.deviceId,
              label: mediaDevice.label || `Camera ${count++}`
            });
          }
        }
      });
      if (this.currentCam == null) {
        this.currentCam = this.currentMediaDevices[0].value;
      }
    },
    stopMediaTracks(stream) {
      stream.getTracks().forEach(track => {
        track.stop();
      });
    }
  },
  async mounted() {
    navigator.mediaDevices.enumerateDevices().then(this.getMediaDevices);
    this.canvasArea = document.querySelector("#canvas");
    this.videoArea = document.querySelector("#video");
    this.currentStream = await navigator.mediaDevices.getUserMedia(this.constraints);
    this.videoArea.srcObject = this.currentStream;
  },
  async beforeDestroy() {
    if (this.currentStream !== "undefined" && this.currentStream != null) {
      await this.stopMediaTracks(this.currentStream);
      this.currentStream = null;
    }

    if (this.interval != null) {
      clearInterval(this.interval);
    }
  },
  computed: {}
};
</script>

<style lang="less">
#camera-dialog {
  .select-div {
    margin-bottom: 16px;
  }

  .canvas-area {
    overflow: hidden;
    border-radius: 8px;
    overflow: hidden;
    aspect-ratio: 1;

    #canvas {
      object-fit: cover;
      aspect-ratio: 1;
      width: 100%;
      height: auto;
    }
  }

  .camera-area {
    position: relative;
    overflow: hidden;
    border-radius: 8px;
    overflow: hidden;
    aspect-ratio: 1;
    mask-image: radial-gradient(circle, black 50%, rgba(0, 0, 0, 0.5) 50%);
    -webkit-mask-image: radial-gradient(circle, black 50%, rgba(0, 0, 0, 0.5) 50%);

    #video {
      object-fit: cover;
      aspect-ratio: 1;
      width: 100%;
      height: auto;
      transform: rotateX("180deg");
    }

    span {
      position: absolute;
      color: white;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      font-size: 120px;
      font-weight: 600;
      text-shadow: 0px 0px 16px rgba(0, 0, 0, 0.45);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/participants/dialog/AddPictureCamera.vue